import { Form } from 'antd'
import KFormList from 'app/components/Modules/Form/KFormList'
import KInputText from 'app/components/Modules/Form/KInputText'
import KSelect from 'app/components/Modules/Form/KSelect'
import { RecordType } from 'app/constants/GlobalTypes'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'
import { Fragment } from 'react'

const CategoryAttributesFormList: React.FC = () => {
  const { form } = useKFormContext()
  const { tAttribute } = ToolBox.useString()
  const categoryAttributes: ICategoryAttribute[] = Form.useWatch('category_attributes', {
    form,
    preserve: true
  })

  const renderInput = (categoryAttribute: ICategoryAttribute) => {
    switch (categoryAttribute.attribute_detail.attribute_type) {
      case 'list':
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          <KSelect
            options={categoryAttribute.attribute_detail.feature_values.map((str) => ({
              label: str,
              value: str
            }))}
            optionLabelProp={'id'}
            selectValueBy={'value'}
            showSearch={false}
          />
        )
      case 'decimal':
        return (
          <KInputText addonAfter={categoryAttribute.metric} hasFeedback={false} type="number" />
        )
      default:
        return <KInputText addonAfter={categoryAttribute.metric} hasFeedback={false} />
    }
  }

  return (
    <KFormList name="category_attributes">
      {() =>
        (categoryAttributes || []).map((categoryAttribute, index) => (
          <Fragment key={`question-${index}-${categoryAttribute.id}`}>
            <KInputText hidden name={[index, 'attribute_value', 'id']} />
            <KInputText hidden name={[index, 'attribute_detail', 'id']} />
            {React.cloneElement(renderInput(categoryAttribute), {
              name: [index, 'attribute_value', 'display_value'],
              label: categoryAttribute.question_text,
              rules: [
                {
                  message: categoryAttribute.question_short_text
                    ? tAttribute({
                        recordType: RecordType.category_attribute,
                        attribute: 'question_short_text',
                        values: {
                          question: categoryAttribute.question_short_text
                        }
                      })
                    : undefined,
                  required: true
                }
              ]
            })}
          </Fragment>
        ))
      }
    </KFormList>
  )
}

export default CategoryAttributesFormList
